import {SmartComponentManager} from "smart-component-js";
import FormCtrl from "./controllers/FormCtrl";
import DefaultCtrl from "./controllers/DefaultCtrl";
import HomeCtrl from "./controllers/HomeCtrl";
import FeedbackModalComponent from "./components/FeedbackModalComponent";
import VisualParallaxComponent from "./components/VisualParallaxComponent";
import AreaPersonaleCtrl from "./controllers/AreaPersonaleCtrl"
import CompletaDatiCtrl from "./controllers/CompletaDatiCtrl"
import HaiVintoCtrl from "./controllers/HaiVintoCtrl"
import AssociaNumeroCtrl from "./controllers/AssociaNumeroCtrl";
import $ from "jquery";
import '../less/mb-promo.less';


SmartComponentManager.registerComponents({
	DefaultCtrl,
	VisualParallaxComponent,
	FeedbackModalComponent,
	FormCtrl,
	AreaPersonaleCtrl,
	CompletaDatiCtrl,
	HaiVintoCtrl,
	AssociaNumeroCtrl,
	HomeCtrl
});



$(document).ready(() => {
	let $body = $('.mb-promo');
	SmartComponentManager.initComponentByName($body[0], $body.attr('component'));
});


